import { render, staticRenderFns } from "./StudentDashboardUnderstanding.vue?vue&type=template&id=487fdb26&scoped=true&lang=pug&"
import script from "./StudentDashboardUnderstanding.vue?vue&type=script&lang=ts&"
export * from "./StudentDashboardUnderstanding.vue?vue&type=script&lang=ts&"
import style0 from "./StudentDashboardUnderstanding.vue?vue&type=style&index=0&id=487fdb26&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "487fdb26",
  null
  
)

export default component.exports